import style from "./layout.module.css";
import { useAppSelector } from "../../store/hooks";
import { GameStep } from "../../types/config";
interface Iprop {
  children: React.ReactNode;
}
const Wrapper: React.FC<Iprop> = ({ children }) => {
  const { gameSteps } = useAppSelector((state) => state.config);

  return (
    <div className={`${style.wrapper} main-app`} id="light">
      <div className={style.main}>{children}</div>
    </div>
  );
};

export default Wrapper;
